import { defineStore, acceptHMRUpdate } from "pinia";
import { ref, watch } from "vue";
import Cookies from "js-cookie";

export const useAppStateStore = defineStore("appState", () => {
  const navCollapsed = ref(Cookies.get("navCollapsed") === "true");
  const settings = ref({
    tab: undefined as string | undefined,
    filter: {
      event_ids: undefined as number[] | undefined,
    },
  });
  const breadcrumbs = ref([]);
  const error = ref<string | undefined>(undefined);

  watch(
    () => Cookies.get("navCollapsed"),
    (newValue) => {
      navCollapsed.value = newValue === "true";
    },
  );

  return {
    navCollapsed,
    settings,
    breadcrumbs,
    // TODO: remove this
    error,

    setNavCollapsed: (value: boolean) => {
      Cookies.set("navCollapsed", String(value));
      navCollapsed.value = value;
    },
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAppStateStore, import.meta.hot));
}
